export default __webpack_public_path__ + "static/media/1.ecb57f62.jpg";